import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { modal } from 'react-redux-modal';
import {
  FeedbackModal
} from '../../../components';

import './styles.scss';
import { modalViewGA } from '../../../utils/googleAnalytics';
import TrackedButton from '../../Buttons/TrackedButton';

const contextTypes = {
  router: PropTypes.object
};

const iOSUrl = 'https://itunes.apple.com/us/app/explore-org/id534289239?platform=iphone&preserveScrollPosition=true#platform/iphone';
const appleTVUrl = 'https://apps.apple.com/us/app/explore-org/id534289239#?platform=appleTV';
const androidUrl = 'https://play.google.com/store/apps/details?id=com.actolap.explore&hl=en_US';

class DownloadAppModal extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.onFeedback = this.onFeedback.bind(this);
  }

  closeModal(e) {
    e.preventDefault();
    this.props.removeModal();
  }

  componentDidMount() {
    modalViewGA('downloadAppModal');
  }

  onFeedback (e) {
    e.preventDefault();
    modal.clear();
    modal.add(FeedbackModal, {size:'medium', hideTitleBar: true});
  }

  render() {
    const { currentItem } = this.props;

    return (
      <div className="modals-popup partner-modal u-font-foundation-roman">
        <div className="modal-header d-flex align-items-center">
          <div className="col">explore.org - never stop learning</div>
          <div className="text-right">
            <a className="closer" href="#" onClick={this.closeModal}></a>
          </div>
        </div>
        <div className="info">
          <div className="mb-20">
            <div className="d-flex justify-content-center mb-20">

              <TrackedButton
                type="link"
                to={iOSUrl}
                target="_blank"
                className="video-player-btn green-btn d-inline-block text-btn u-font-foundation-roman text-uppercase"
                title="iPhone/iPad"
                action={iOSUrl}
              />

              <TrackedButton
                type="link"
                to={appleTVUrl}
                target="_blank"
                className="video-player-btn green-btn d-inline-block text-btn u-font-foundation-roman text-uppercase"
                title="Apple TV"
                action={appleTVUrl}
              />

              <TrackedButton
                type="link"
                to={androidUrl}
                target="_blank"
                className="video-player-btn green-btn d-inline-block text-btn u-font-foundation-roman text-uppercase"
                title="Android"
                action={androidUrl}
              />

            </div>
            <div className="">
              <p>Download the Explore2Go App so you can take it on your mobile
              device this summer!  Newly designed and simple to use, the
              explore.org mobile app is the Netflix of Live Nature. Escape stress,
              connect with nature and share with your friends!</p>
              <p>Rick Hemingway</p>
              <p>Editor and Curator in Chief</p>
            </div>
            <div className="d-flex justify-content-end">
              <button className="video-player-btn text-btn inverse-btn text-uppercase"
                onClick={(e)=>{this.onFeedback(e)}}>
                <div>feedback</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

}
const mapStateToProps = (state) => {
  return {
    currentItem: state.currentItem.data,
  };
}
DownloadAppModal.contextTypes = contextTypes;
export default connect(mapStateToProps)(DownloadAppModal);
